import axios from 'axios';
import { refreshAccessToken, logout, getAccessToken } from './authService';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor
api.interceptors.request.use(config => {
    const token = getAccessToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => Promise.reject(error));

// Response interceptor
api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (
            error.response?.status === 401 &&
            !originalRequest._retry &&
            !originalRequest.url.includes("refreshToken")
            && !originalRequest.url.includes("login")
            && !originalRequest.url.includes("totp")
        ) {
            originalRequest._retry = true;

            if (isRefreshing) {
                return new Promise(function (resolve, reject) {
                    failedQueue.push({
                        resolve: (token) => {
                            originalRequest.headers['Authorization'] = 'Bearer ' + token;
                            resolve(api(originalRequest));
                        },
                        reject: (err) => {
                            reject(err);
                        }
                    });
                });
            }

            isRefreshing = true;

            try {
                console.trace("Token refresh triggered");
                const { payload } = await refreshAccessToken(); // You return full response in `refreshAccessToken`
                const newToken = payload.accessToken;

                // Set for next requests
                api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                processQueue(null, newToken);

                return api(originalRequest);
            } catch (err) {
                processQueue(err, null);
                logout();
                return Promise.reject(err);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default api;
